import moment from 'moment';
import { getMetricDisplayName, isMetricIncluded } from '@utils/metrics';
import { TOOLTIP_LABEL_FORMAT } from '@utils/constants';
import { annotationExportHeader } from '@components/annotations/hooks/utils';
import useFetchAnnotations from '@components/annotations/hooks/useFetchAnnotations';
import useSetExport from '../../export/useSetExport';
import { buildIntervalText } from '../../export/parsers';

function useSetAnnotationsExport({ interval = null, metrics = [] }) {
  const { data: rawList = [] } = useFetchAnnotations({ interval, fetchRawData: true });
  const parsedData = formatAnnotationsData(metrics, rawList);
  const flattenMetricList = metrics
    .map((metricKey) => {
      getMetricDisplayName({
        metricKey,
      });
    })
    .toString();

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'annotations',
    widgetKey: 'annotations',
    headers: annotationExportHeader,
    data: parsedData,
    widgetInfo: {
      title: metrics.length
        ? `Annotations for ${flattenMetricList} (${buildIntervalText(interval)})`
        : `All annotations (${buildIntervalText(interval)})`,
    },
  });
}

const formatAnnotationsData = (metricKeys: string[] = [], rawList) => {
  const allAnnotationsData = rawList.map((annotation) => ({
    ...annotation,
    xAxis: moment(annotation.endTimestamp).format(TOOLTIP_LABEL_FORMAT),
    metric: annotation.annotationType === 'all' ? 'All' : annotation.metricKey,
    sourceMetric: getMetricDisplayName({ metricKey: annotation.metricKey }),
    type: annotation.isPublic ? 'Public' : 'Private',
    comments: annotation.comments.map((comment) => comment.description),
  }));
  if (metricKeys.length) {
    return allAnnotationsData.filter(
      (annotation) =>
        isMetricIncluded(metricKeys, annotation.metric) || annotation.annotationType === 'all',
    );
  } else return allAnnotationsData;
};

export default useSetAnnotationsExport;
